import { HttpClient } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { CustomTranslateLoaderService } from '@app/core/translation/custom-translate-loader.service';
import { environment } from '@env/environment';
import { loadInjector } from '@le_cedre/portal-lib';

import { ActionReducer, MetaReducer } from '@ngrx/store';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new CustomTranslateLoaderService(http);
}

export function debugLog(reducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<any>[] = environment.production ? [] : [debugLog];

@NgModule(/* TODO(standalone-migration): clean up removed NgModule class manually. 
{
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        PortalLibModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        MatButtonModule,
        SatPopoverModule,
        MatProgressSpinnerModule,
        NgxCaptchaModule,
        SocialLoginModule,
        MatIconModule,
        StoreModule.forRoot(portalNgrxReducers, { metaReducers }),
        !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
        EffectsModule.forRoot([...portalNgrxEffects]),
        PageNotFoundComponent,
        FirstLogComponent,
        EntitySelectorPageComponent,
        LoginComponent,
        LoginFormComponent,
    ],
    providers: [
        { provide: ENV_PROVIDER_TOKEN, useExisting: PortalEnvironnementProvider },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(environment.commonOptions.googleClientId),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
} */)
export class AppModule {
    // Do not delete state injector (necessary because of loadInjector)
    constructor(injector: Injector) {
        loadInjector(injector);
    }
}
